import React, { Component } from 'react'
import Navbar from '../Components/NavBar'
import Footer from '../Components/Footer'
import Courses from '../Components/Courses'

export class CoursesPage extends Component {
  render() {
    return (
      <div>
        <Navbar/>
        <Courses/>
        <Footer/>
      </div>
    )
  }
}

export default CoursesPage
